export const environment = {
  version: '1.21a',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
